import { SearchSortType } from '@/app/(main)/(pages)/busca/[slug]/_types/search-sort.type';
import { SearchApiOrderBy } from '@/app/(main)/(pages)/_types/search-api-response.type';

const SEARCH_API_ORDER_BY: Partial<Record<SearchSortType, SearchApiOrderBy>> = {
  [SearchSortType.DISTANCE]: 'DISTANCE',
  [SearchSortType.PRICE]: 'PRICE',
  [SearchSortType.RATING]: 'RATING',
};

export function toSearchApiOrderBy(orderBy?: SearchSortType): SearchApiOrderBy | undefined {
  return orderBy ? SEARCH_API_ORDER_BY[orderBy] : undefined;
}
